
import digitalmarketing from "../../../../../images/LandingPageImage/mn_image_1.webp"
import support from "../../../../../images/LandingPageImage/mn_image_2.webp";
import sales from "../../../../../images/LandingPageImage/mn_image_3.webp";
import '../../styles/LandingPageCss/Achivement.css'


const contentItems = [
    {
        title: "Marketing",
        descTitle: "Self service Customer Support without a human touch",
        desc2: "When your business expands, it is hard to manage all the conversations by hand, and it is time-consuming.",
        img: digitalmarketing,
        bgColor: "bg-pale"
    },
    {
        title: "Support",
        descTitle: "Universal Inbox to enhance team work",
        desc2: "Different channels of dealing with customer messages can easily be overwhelming. Message Notifier addresses this by providing a single inbox where the conversations are structured at a single place.",
        img: support,
        bgColor: "bg-ryleigh"
    },
    {
        title: "Sales",
        descTitle: "Innovative to Enhance Customer Experience",
        desc2: "Customer communication in a positive way starts with concise and punctual communication. Message Notifier aims at assisting the businesses to have better relationship by not missing any message and making sure that no customer feels ignored.",
        img: sales,
        bgColor: "bg-coral"
    },
];

export default function Achivement() {

    return (
        <section className="achievement-section py-20">

            
            <div className="container text-center">
                <h2 className="new-section-title">
                    Meet Customers In The most
                    <br className="d-none d-sm-block" />
                    Active Areas
                </h2>

                <p className="achievement-subtitle mt-3">
                    Messaging applications, particularly WhatsApp, use a lot of time by customers. Message Notifier helps companies to communicate to their audience through platforms that they already trust and use on a daily basis. Businesses can send messages that are not picked up, read and acted upon, just because they do not have to use emails which are not opened or calls which are not answered.
                </p>
                <p className="achievement-subtitle mt-3">Could you be updating, carrying out promotional activities or communicating with your service users, Message Notifier is certain to ensure that you are communicating to the right individuals at the right time and with the right message.</p>
            </div>

            
            <div className="container mt-10">
                <div className="row g-4 g-lg-5">

                    {contentItems.map((item, index) => (
                        <div key={index} className="col-12 col-sm-6 col-lg-4 mb-4 mb-sm-5 ">

                            <h3 className="text-center fw-semibold  achievement-card-title">
                                {item.title}
                            </h3>

                            <div className={`p-4 shadow-sm h-100 ${item.bgColor}`}>
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    className="img-fluid mb-4 rounded"
                                />

                                <h4 className="fw-semibold mb-2 achievement-desc-title">
                                    {item.descTitle}
                                </h4>

                                <p className="text-muted mb-0 achievement-desc">
                                    {item.desc2}
                                </p>
                            </div>

                        </div>
                    ))}

                </div>
            </div>

        </section>
    );
}














